module.exports = __webpack_public_path__ + "resources/img/img_tibero4_m_jp.7cf1bfd7aa96a3ed325351f399301229.png";